import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="min-h-[70vh] flex items-center justify-center px-4">
      <div className="w-full max-w-md rounded-2xl border border-zinc-800 bg-zinc-950/80 p-8 text-center animate-fade-up">
        <XCircle className="h-12 w-12 text-zinc-500 mx-auto mb-4" />
        <h1 className="font-serif text-2xl text-zinc-100">Betaling geannuleerd</h1>
        <p className="text-sm text-zinc-400 mt-3">
          Je advertentie is nog niet gepubliceerd. Je kunt de betaling later opnieuw starten vanuit je dashboard.
        </p>
        <Link to="/dashboard" data-testid="cancel-to-dashboard" className="inline-block mt-6 rounded-lg bg-rose-600 hover:bg-rose-500 text-white font-medium px-5 py-3">
          Naar dashboard
        </Link>
      </div>
    </div>
  );
}
